<div class="container">
  <div class="wrapper">
    <h2 class="title">{{ text }}</h2>
  </div>
</div>
